/**
 * @module hooks/settingsRecalcPolicy
 * @description Confirm 变更检测 — 纯函数，供 useSettingsDraft 与契约测试复用
 */

import { getNotCalculateKeys } from '../../manifest/recalcPolicy';

export function computeChangedSettingKeys(input: {
  base: Record<string, unknown>;
  draft: Record<string, unknown>;
  hasDraft: Record<string, boolean>;
}): string[] {
  const { base, draft, hasDraft } = input;
  const keys = new Set([
    ...Object.keys(draft),
    ...Object.keys(hasDraft).filter(key => hasDraft[key] && !(key in draft)),
  ]);

  return [...keys].filter(key => {
    if (!(key in draft) && hasDraft[key]) {
      return key in base;
    }
    return draft[key] !== base[key];
  });
}

export function computeNeedsRecalculation(changedKeys: string[]): boolean {
  const notCalculateKeys = getNotCalculateKeys();
  return (
    changedKeys.length > 0 &&
    !changedKeys.every(key => notCalculateKeys.has(key))
  );
}
